var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurtleGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65352 4.34375L9.47102 7H5.63477L6.24789 4.34375H8.65352Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 3.40625L4.78125 1.39125C5.56375 0.96 6.46812 0.75 7.43687 0.75C8.38687 0.75 9.2925 0.965 10.0806 1.4075L8.74812 3.40625H6.125Z",
    fill: "#707070"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51367 3.94781L10.8487 1.94531C11.9443 2.89719 12.6787 4.44031 12.7393 6.67531C12.7443 6.85031 12.5993 6.99781 12.4243 6.99781H10.4524L9.51367 3.94781Z",
    fill: "#707070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.12903 6.68094C2.19153 4.42969 2.91153 2.88031 4.01216 1.92969L5.37278 3.97031L4.67216 7.00344H2.44466C2.26903 7.00344 2.12403 6.85594 2.12903 6.68094Z",
    fill: "#707070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7508 8.25C17.7508 7.335 17.414 5.75 15.8758 5.75C14.124 5.75 13.5996 6.82437 13.4427 7.4675C13.3746 7.74562 13.1246 7.9375 12.8383 7.9375H2.75084C1.16834 7.9375 0.475838 9.49562 0.298963 10.3575C0.266463 10.515 0.436463 10.6369 0.577088 10.5581C1.58521 9.995 2.30646 9.90188 3.03584 10.75L2.78771 11.7438C2.59646 12.5087 3.17521 13.25 3.96396 13.25C4.52021 13.25 5.00521 12.8725 5.14021 12.3325C5.31834 11.6194 5.53584 10.75 5.53584 10.75H9.91084L10.3065 12.3313C10.4415 12.8713 10.9265 13.25 11.4827 13.25C12.2715 13.25 12.8502 12.5088 12.659 11.7431L12.4108 10.75C12.4108 10.75 17.7508 10.7494 17.7508 8.25ZM15.8758 8.25C15.5308 8.25 15.2508 7.97 15.2508 7.625C15.2508 7.28 15.5308 7 15.8758 7C16.2208 7 16.5008 7.28 16.5008 7.625C16.5008 7.97 16.2208 8.25 15.8758 8.25Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtleGrey);
export default __webpack_public_path__ + "static/media/turtle-grey.1af1d5c8cf3a5e6fd4070e1d32877c3e.svg";
export { ForwardRef as ReactComponent };